import React, { useState, useRef, useEffect } from "react";
import { BsChevronDown, BsChevronRight } from "react-icons/bs";
import { HiOutlineCollection, HiOutlineClipboardList, HiOutlineDocumentDuplicate, HiOutlineShieldCheck, HiOutlineBookOpen } from "react-icons/hi";
import "./SideBar.css";
import { useNavigate ,useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { NavLink } from "react-router-dom";

import configurationdark from "./../../../assets/global_assets/dashboard_imgs/configurationdark.png";
import reportdark from "./../../../assets/global_assets/dashboard_imgs/reportdark.png";
import SignOutdark from "./../../../assets/global_assets/dashboard_imgs/SignOutdark.png";
import StaffingAgenciesdark from "./../../../assets/global_assets/dashboard_imgs/StaffingAgenciesdark.png";
import inputmatrixdark from "./../../../assets/global_assets/dashboard_imgs/inputmatrixdark.png";
import dashboardDark from "./../../../assets/global_assets/dashboard_imgs/dashboardDark.png";
import configurationlight from "./../../../assets/global_assets/dashboard_imgs/configurationlight.png";
import reportlight from "./../../../assets/global_assets/dashboard_imgs/reportlight.png";
import SignOutlight from "./../../../assets/global_assets/dashboard_imgs/SignOutlight.png";
import StaffingAgencieslight from "./../../../assets/global_assets/dashboard_imgs/StaffingAgencieslight.png";
import inputmatrixlight from "./../../../assets/global_assets/dashboard_imgs/inputmatrixlight.png";
import dashboardLight from "./../../../assets/global_assets/dashboard_imgs/dashboardLight.png";
import { getUserRole } from "../../../services/global_redux/globale_actions/Role.action";
import inputmatrixlights from "./../../../assets/register_assets/inputMatix/Emp_master/nature_of_working_icon.png";

const Sidebar = ({ sidebarOpen, showSnackbar = () => {} }) => {
  const [openKeys, setOpenKeys] = useState({});
  const sidebarRef = useRef(null);
  const navigate = useNavigate();
  const [permissionsSections, setPermissionsSections] = useState(null);  
  const use_company_code = JSON.parse(sessionStorage.getItem('user'));
  const currentUserBaseRole = use_company_code?.base_role;
  const location = useLocation();
  const dispatch = useDispatch();
  
  const menuItems = [
    { title: "Dashboard", iconDark: dashboardDark, iconLight: dashboardLight, link: "/dashboard" },
    { title: "InputMatrix", iconDark: inputmatrixdark, iconLight: inputmatrixlight, link: "/input-matrix" },
    { title: "Generated Form", iconDark: inputmatrixlights, iconLight: inputmatrixlights, link: "/generated-form" },
    { title: "Reports", iconDark: reportdark, iconLight: reportlight, link: "/report" },
    { title: "Returns", iconDark: StaffingAgenciesdark, iconLight: StaffingAgencieslight, link: "/returns" },
    { title: "Compliance Documents", Icon: HiOutlineDocumentDuplicate, link: "/compliance-documents" },
    // { title: "Certificate", iconDark: inputmatrixdark, iconLight: inputmatrixlight, link: "/certificate" },
      {
      title: "Configuration",
      iconDark: configurationdark, iconLight: configurationlight,
      children: [
        { title: "User permission", link: "/configuration/user-role-management" },
        {
          title: "User & Role Management",
          children: [
            { title: "Create Role", link: "/configuration/user-role-management/role" },
            { title: "Assign Permissions", link: "/configuration/user-role-management/role-permission" },
            { title: "Create Users", link: "/configuration/user-role-management/users" },
            { title: "Assign Client", link: "/configuration/user-role-management/users-client" }
          ]
        },
        { title: "Org Details", link: "/configuration/org-details" },
        { title: "Holidays", link: "/configuration/holidays" },
        { title: "Branch Holidays", link: "/configuration/branch-holidays" },
        { title: "Form Configuration", link: "/configuration/form-configuraion" },
        { title: "Employee Branch Transfer", link: "/configuration/employee-branch-transfer" },
        { title: "Leave Configuration", link: "/configuration/leave-type-configuration" },
        // {
        //   title: "Leave Ops",
        //   children: [
        //     { title: "Leave Type Configuration", link: "/configuration/leave-type-configuration" },
        //     { title: "Leave Opening Balance", link: "/configuration/leave-opening-balance/2025-01" }
        //   ]
        // },
        // { title: "Staffing Agencies", link: "/configuration/staffing-agencies/2025-01" },
        {
          title: "Developer Setting",
          children: [
            { title: "Access Configuration", link: "/configuration/developer-settings/access-configuration" },
            { title: "States", link: "/configuration/developer-settings/configuration/states" },
          ]
        }
      ]
    },
    { title: "Staffing Agencies", iconDark: StaffingAgenciesdark, iconLight: StaffingAgencieslight, link: "/configuration/staffing-agencies/2025-01" },
    { title: "Sign Out", iconDark: SignOutdark, iconLight: SignOutlight, link: "#" }
  ];
  const menuItems1 = [
    { title: "Dashboard", iconDark: dashboardDark, iconLight: dashboardLight, link: "/dashboard" },
    { title: "Company Details", iconDark: inputmatrixdark, iconLight: inputmatrixlight, link: "/company-details" },
      {
      title: "Configuration",
      iconDark: configurationdark, iconLight: configurationlight,
      children: [
        { title: "Act", link: "/act" },
        { title: "Rule", link: "/rule" },
        { title: "Activity", link: "/activity" },
        { title: "Template", link: "/template" }
      ]
    }
  ];

  const menuItemsClient = [
    { title: "Dashboard", iconDark: dashboardDark, iconLight: dashboardLight, link: "/dashboard" },
    {
      title: "Register",
      Icon: HiOutlineCollection,
      children: [
        { title: "Forms", link: "/generated-form" },
        { title: "Reports", link: "/report" },
      ],
    },
    { title: "Returns", Icon: HiOutlineClipboardList, link: "/returns" },
    { title: "Compliance Documents", Icon: HiOutlineDocumentDuplicate, link: "/compliance-documents" },
    // { title: "Remedies", Icon: HiOutlineShieldCheck, link: "/certificate" },
    { title: "User Guide", Icon: HiOutlineBookOpen, link: "/user-guide" },
  ];

  const toggleParent = (key) => {
    setOpenKeys((prev) => {
      if (prev[key]) return {}; // close if already open
      return { [key]: true };   // open only this parent
    });
  };
  
  const toggleChild = (key) => {
    setOpenKeys((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  

  useEffect(() => {
    const handleClick = (e) => {
      if (!sidebarRef.current) return;
      if (!sidebarRef.current.contains(e.target) && !sidebarOpen) {
        setOpenKeys({});
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [sidebarOpen]);

  useEffect(() => {
    const closeMenus = () => setOpenKeys({});
    window.addEventListener("sidebar-close-menus", closeMenus);
    return () => window.removeEventListener("sidebar-close-menus", closeMenus);
  }, []);

  useEffect(() => {
    setOpenKeys({});
  }, []);

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      setOpenKeys({});
    }
  }, [location.pathname]);

  useEffect(() => {
    if (currentUserBaseRole !== "Client") return undefined;
    const openRegister = () => setOpenKeys((prev) => ({ ...prev, Register: true }));
    window.addEventListener("client-tour-open-register", openRegister);
    return () => window.removeEventListener("client-tour-open-register", openRegister);
  }, [currentUserBaseRole]);

  const getUserPermission = async () => {
    try {
        const response = await dispatch(getUserRole());
        setPermissionsSections(response.data);
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };
  useEffect(() => {
    getUserPermission();
  }, [dispatch]);

  const formatValidPermissions = (permissions) => {
    const result = {};

    if (permissions && typeof permissions[0] === "string") {
        try {
            permissions = JSON.parse(permissions[0]);
        } catch (e) {
            console.error("Invalid JSON format", e);
            return result;
        }
    }
    if(permissions){
        permissions.forEach(({ section, module, sub_module }) => {
            if (!section || !module) return;

            // If sub_module is a valid array, filter only those with at least one true action
            if (Array.isArray(sub_module)) {
              const validSubModules = sub_module.filter((sub) => sub && sub.name);

              if (!result[section]) result[section] = {};

              result[section][module] = validSubModules.length > 0
                ? validSubModules.map(sub => sub.name)
                : sub_module.map(sub => sub.name);
            }else {
              // If no sub_module array, still add the module with an empty array
              if (!result[section]) result[section] = {};
              result[section][module] = [];
            }
          });
    }

    return result;
  };
  if(permissionsSections){
    var permissionMap = formatValidPermissions(permissionsSections.permissions);
    
  }else{
    var permissionMap = null;
  }
  const filterMenuByPermission = (items, permissions) => {
    if (!permissions || typeof permissions !== "object") {
      permissions = {};
    }
  
    return items
      .map((item) => {
        if (["Dashboard","Reports","Returns","Certificate","States","Compliance Documents","User Guide"].includes(item.title)) {
          return item;
        }
  
        if (item.children) {
          const permForItem = permissions[item.title];
  
          if (Array.isArray(permForItem)) {
            if (permForItem.length === 0) {
              return { ...item, children: [] };
            }
            const allowedChildren = item.children.filter((child) =>
              permForItem.includes(child.title)
            );
            if (allowedChildren.length > 0) {
              return { ...item, children: allowedChildren };
            }
            return null;
          }
  
          if (typeof permForItem === "object" && permForItem !== null) {
            const filteredChildren = filterMenuByPermission(
              item.children,
              permForItem
            );
            if (filteredChildren.length > 0) {
              return { ...item, children: filteredChildren };
            }
  
            if (permissions.hasOwnProperty(item.title)) {
              return { ...item, children: [] };
            }
            return null;
          }
  
          return null;
        }
  
        const perm = permissions[item.title];

        if (Array.isArray(perm)) {
          return item;
        }

        if (
          item.link &&
          item.title === 'Employee Branch Transfer' &&
          Array.isArray(permissions['Form Configuration'])
        ) {
          return item;
        }

        if (typeof perm === "object" && perm !== null) {
          return item;
        }

        return null;
      })
      .filter(Boolean);
  };
  
  
  if(currentUserBaseRole === "SuperiorAdmin"){
    var filteredMenuItems = menuItems1;
  } else if(currentUserBaseRole === "Client"){
    var filteredMenuItems = menuItemsClient;
  } else{
    var filteredMenuItems = filterMenuByPermission(menuItems, permissionMap);
  }

  const isActive = (item, parentKey = "") => {
    if (item.link) {
      if (item.title === "User Guide" || item.link === "/user-guide") {
        return location.pathname.startsWith("/user-guide");
      }
      if (item.title === "Certificate" || item.title === "Remedies") {
        return location.pathname.startsWith("/certificate");
      }
      if (item.title === "Compliance Documents" || item.link === "/compliance-documents") {
        return location.pathname.startsWith("/compliance-documents");
      }
      if (item.title === "Reports" || item.link === "/report") {
        return (
          location.pathname === "/report" ||
          location.pathname.startsWith("/report/") ||
          location.pathname.startsWith("/reports/")
        );
      }
      if (
        item.title === "Generated Form" ||
        item.title === "Forms" ||
        item.link === "/generated-form"
      ) {
        return location.pathname.startsWith("/generated-form");
      }
      if (item.title === "InputMatrix" || item.link === "/input-matrix") {
        return (
          location.pathname === "/input-matrix" ||
          location.pathname.startsWith("/input-matrix/")
        );
      }
      if (location.pathname === item.link) {
        return true;
      }
    }

    if (item.children) {
      return item.children.some((child) =>
        isActive(child, `${parentKey}/${child.title}`)
      );
    }

    return false;
  };
  const renderItem = (item, parentKey = "") => {
    const key = parentKey ? `${parentKey}/${item.title}` : item.title;
    const isOpen = !!openKeys[key];
    const hasChildren = Array.isArray(item.children) && item.children.length > 0;
  
    const handleClick = (e) => {
      e.stopPropagation();
      if (hasChildren) {
        if (key.split("/").length === 1) {
          toggleParent(key);
        } else {
          toggleChild(key);
        }
      } else if (item.link) {
        navigate(item.link);
        if (!sidebarOpen || !parentKey) {
          setOpenKeys({});
        }
      }
    };
    const active = isActive(item);
    const tourId =
      item.link === "/dashboard" || item.title === "Dashboard"
        ? "nav-dashboard"
        : item.link === "/generated-form" || item.title === "Forms"
        ? "nav-forms"
        : item.link === "/report" || item.title === "Reports"
        ? "nav-reports"
        : item.link === "/returns" || item.title === "Returns"
        ? "nav-returns"
        : item.link === "/compliance-documents" || item.title === "Compliance Documents"
        ? "nav-docs"
        : item.link === "/user-guide" || item.title === "User Guide"
        ? "nav-guide"
        : item.title === "Register"
        ? "nav-register"
        : undefined;
    return (
      <li
      className={`nav-item pt-1 position-relative menu-item sidebarnavalighnment my-1 ${
        sidebarOpen ? "heightAndWidthofnav" : "compresedheightAndWidthofnav"
      } ${active ? "active-nav" : ""} ${!sidebarOpen && isOpen ? "collapsed-flyout-open" : ""}`}
      key={key}
      {...(tourId ? { "data-tour": tourId } : {})}
    >
      <div
        className="nav-link d-flex align-items-center"
        style={{ cursor: "pointer" }}
        onClick={handleClick}
      >
        {item.Icon ? (
          <span className="sideBaricon">
            <item.Icon className="sideBarSvgIcon" />
          </span>
        ) : item.iconDark ? (
          <span className="sideBaricon">
            <img
              src={active ? item.iconLight : item.iconDark}
              alt=""
            />
          </span>
        ) : null}
        <span className="label flex-grow-1 sideBarlabel hover-text-white">
          {item.title}
        </span>
        {hasChildren && sidebarOpen && (
          <BsChevronDown className={`ms-auto ${isOpen ? "rotate-180" : ""} ${active ? "text-white" : "text-dark"}`} />
        )}
      </div>

      {sidebarOpen && hasChildren && isOpen && (
        <ul className="nav flex-column submenu-lines">
          {item.children.map((child) => renderItem(child, `${key}/${child.title}`))}
        </ul>
      )}

      {!sidebarOpen && hasChildren && (
        <ul className="nav flex-column floating-submenu p-2 bg-white shadow rounded">
          {item.children.map((child) => {
            const childKey = `${key}/${child.title}`;
            const childActive = isActive(child);
            return (
              <li key={childKey} className={`nav-item position-relative p-0 m-0 dropdown-submenu ${
                childActive ? "active-subnav" : ""
              }`}
              >
                <div
                  className="nav-link d-flex align-items-center mx-0 sidebarchildnavwidth"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (child.children) {
                      return;
                    }
                    if (child.link) {
                      navigate(child.link);
                      setOpenKeys({});
                    }
                  }}
                >
                  {child.Icon ? (
                    <span className="sideBaricon">
                      <child.Icon className="sideBarSvgIcon" />
                    </span>
                  ) : child.iconDark ? (
                    <span className="sideBaricon">
                      <img
                        src={
                          childActive
                            ? child.iconLight
                            : child.iconDark
                        }
                        alt=""
                      />
                    </span>
                  ) : null}
                  <span className="sideBarlabel">{child.title}</span>
                  {child.children && (
                    <BsChevronRight
                      className={`ms-auto ${childActive ? "text-white" : "text-dark"}`}
                    />
                  )}
                </div>
                {child.children && (
                  <ul className="nav flex-column nested p-2 bg-white shadow rounded">
                    {child.children.map((g) => (
                      <li className="nav-item m-0 p-0" key={`${childKey}/${g.title}`}>
                        <a
                          className="nav-link"
                          href={g.link ?? "#"}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (g.link) navigate(g.link);
                            setOpenKeys({});
                          }}
                        >
                         <span className="sideBarlabel"> {g.title}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </li>
    );
  };

  return (
    <aside
    ref={sidebarRef}
    className={`sidebar bg-white text-black sticky-top ${
      sidebarOpen ? "widthOut" : "widthIn"
    }`}
  >
    <ul className="nav flex-column p-2 checkwidth ">
    {/* {currentUserBaseRole === "SuperiorAdmin" ? <>
    <li className={`nav-item pt-1 position-relative menu-item sidebarnavalighnment my-1 ${
        sidebarOpen ? "heightAndWidthofnav" : "compresedheightAndWidthofnav"
      }`}>
        <NavLink
        className="nav-link d-flex align-items-center"
        style={{ cursor: "pointer" }}
        to="/dashboard"
      >
        <span className="sideBaricon"><img src={dashboardDark} alt="" /></span>
      <span className="label flex-grow-1 sideBarlabel hover-text-white">Dashboard</span>
      </NavLink>
      </li>
    <li className={`nav-item pt-1 position-relative menu-item sidebarnavalighnment my-1 ${
        sidebarOpen ? "heightAndWidthofnav" : "compresedheightAndWidthofnav"
      }`}>
        <NavLink
        className="nav-link d-flex align-items-center"
        style={{ cursor: "pointer" }}
        to="/company-details"
      >
        <span className="sideBaricon"><img src={dashboardDark} alt="" /></span>
      <span className="label flex-grow-1 sideBarlabel hover-text-white">Company Details</span>
      </NavLink>
      </li>
    </>:
    <> */}
    {filteredMenuItems.map((m) => renderItem(m))}
    {/* </>
    } */}
    
    </ul>
  </aside>
  );
};

export default Sidebar;
